import { DARK, LIGHT } from "src/styles/themes";
import styled, { css, keyframes } from "styled-components";

export const LoadingIndicator = styled.div<{ size?: string }>`
  transform: rotateZ(45deg);
  perspective: 1000px;
  border-radius: 50%;
  width: ${(props) => props.size || "48px"};
  height: ${(props) => props.size || "48px"};
  color: ${(props) => props.theme.gray};

  ::before,
  ::after {
    content: "";
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: inherit;
    height: inherit;
    border-radius: 50%;
    transform: rotateX(70deg);
    animation: 1s spin linear infinite;
  }

  ::after {
    color: ${(props) => props.theme.brandPrimary};
    transform: rotateY(70deg);
    animation-delay: 0.4s;
  }

  @keyframes spin {
    0%,
    100% {
      box-shadow: 0.5rem 0px 0 0px currentColor;
    }
    .52% {
      box-shadow: 0.5rem 0.5rem 0 0 currentColor;
    }
    25% {
      box-shadow: 0 0.5rem 0 0px currentColor;
    }
    37% {
      box-shadow: -0.5rem 0.5rem 0 0 currentColor;
    }
    50% {
      box-shadow: -0.5rem 0 0 0 currentColor;
    }
    62% {
      box-shadow: -0.5em -0.5rem 0 0 currentColor;
    }
    75% {
      box-shadow: 0px -0.5rem 0 0 currentColor;
    }
    87% {
      box-shadow: 0.5rem -0.5rem 0 0 currentColor;
    }
  }
`;

export const PageLoadingWrapper = styled.div<{ height?: string }>`
  align-items: center;
  display: flex;
  height: 100vh;
  justify-content: center;
  left: 0;
  margin: -16px 0 0 -16px;
  position: absolute;
  top: 0;
  width: 100%;
`;

const LOADING_BACKGROUND_IMAGES: { [k: string]: string } = {
  [DARK]:
    "PHN2ZyB3aWR0aD0iMzgiIGhlaWdodD0iMzgiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgc3Ryb2tlPSIjMjQyODMzIj48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxIDEpIiBzdHJva2Utd2lkdGg9IjIiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+PGNpcmNsZSBzdHJva2Utb3BhY2l0eT0iLjUiIGN4PSIxOCIgY3k9IjE4IiByPSIxOCIvPjxwYXRoIGQ9Ik0zNiAxOGMwLTkuOTQtOC4wNi0xOC0xOC0xOCIvPjwvZz48L3N2Zz4=",
  [LIGHT]:
    "PHN2ZyB3aWR0aD0iMzgiIGhlaWdodD0iMzgiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgc3Ryb2tlPSIjZmZmZmZmIj48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxIDEpIiBzdHJva2Utd2lkdGg9IjIiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+PGNpcmNsZSBzdHJva2Utb3BhY2l0eT0iLjUiIGN4PSIxOCIgY3k9IjE4IiByPSIxOCIvPjxwYXRoIGQ9Ik0zNiAxOGMwLTkuOTQtOC4wNi0xOC0xOC0xOCIvPjwvZz48L3N2Zz4=",
};

export const loading = (size: string, color = DARK) => css`
  display: inline-block;
  width: ${size};
  height: ${size};
  background: url('data:image/svg+xml;base64,${LOADING_BACKGROUND_IMAGES[color]}') no-repeat center;
  background-size: ${size};
  animation: ${rotate} 0.4s linear infinite;
`;

export const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;

export const Loader = styled.div<{ light?: boolean }>`
  ${(p) => loading("14px", p.light ? LIGHT : DARK)};
`;